import { t } from '../i18n/lingua'

/**
 * Come si prepara AWS per CENSO: la policy di sola lettura e, per il software
 * installato sulle EC2, Systems Manager Inventory. Accanto al modulo della
 * credenziale AWS, chiusa di default. Il testo completo, con la policy da
 * copiare, è in docs/operations/aws-permessi.md.
 */
export function GuidaAws() {
  return (
    <details className="guida-chiave">
      <summary>{t('Come preparo AWS per CENSO, compreso il software delle EC2?')}</summary>
      <div className="guida-chiave__corpo">
        <p>
          {t(
            'CENSO legge AWS con permessi di sola lettura, meglio assumendo un ruolo dedicato: EC2, VPC, volumi, gruppi di sicurezza, S3, Lambda, RDS, bilanciatori e i costi del mese. Il software installato sulle EC2 arriva da AWS Systems Manager Inventory: CENSO interroga AWS, non le macchine.',
          )}
        </p>
        <h4>{t('A) La policy del ruolo')}</h4>
        <ol>
          <li>
            {t(
              'Crea un ruolo IAM per CENSO con la policy di sola lettura della guida dei permessi AWS: comprende ssm:DescribeInstanceInformation, ssm:ListInventoryEntries e ssm:DescribeInstancePatchStates, le sole tre azioni di Systems Manager, tutte in lettura (niente ssm:SendCommand, nessuna esecuzione sulle istanze).',
            )}
          </li>
          <li>
            {t(
              'Nella fiducia del ruolo indica l’account o l’utenza che lo assume e un External ID; qui metti l’ARN del ruolo e lo stesso External ID.',
            )}
          </li>
        </ol>
        <h4>{t('B) Il software delle EC2 (Systems Manager Inventory)')}</h4>
        <ol>
          <li>
            {t(
              'Sulle EC2 serve l’agente SSM (già presente sulle immagini Amazon Linux, Ubuntu e Windows di AWS) e un profilo d’istanza con la policy AmazonSSMManagedInstanceCore.',
            )}
          </li>
          <li>
            {t(
              'Attiva la raccolta: console AWS → Systems Manager → Inventory → «Setup Inventory» (oppure Quick Setup → Host Management), per tutte le istanze o per tag. Di default raccoglie ogni 30 minuti.',
            )}
          </li>
          <li>
            {t(
              'Nella credenziale AWS accendi «Attiva import avanzato»: senza, CENSO non interroga Systems Manager e il rapporto del job lo ricorda.',
            )}
          </li>
          <li>
            {t(
              'Al job successivo, sulla scheda di ogni EC2 gestita compaiono il software installato (fonte «ssm»), il sistema operativo reale, gli aggiornamenti Windows e i servizi in esecuzione. Il rapporto del job elenca le EC2 non gestite da SSM o gestite senza Inventory: sono i buchi da chiudere.',
            )}
          </li>
        </ol>
      </div>
    </details>
  )
}
